import React, { useState, useEffect } from "react";
import { Typography, Collapse, Pagination, Table, Button } from "antd";
import { EditOutlined, DeleteOutlined} from "@ant-design/icons";
import Pageloader from "../../../../components/loader";
import TageComponents from "../../../../components/tageComponents";
import { useNavigate } from "react-router-dom";
import { dataKey } from "../../../../utils/Helpers";
import moment from "moment";
import NotificationFilter from "./filter";
import * as notificationAction from "../../../../redux/actions/notification.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Title, Text } = Typography;
const { Panel } = Collapse;

const pageName = "Notification";
const pageLink = "notification";

const NotificationListing = (props) => {
  const navigate = useNavigate();
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(props.notificationFilter)
      postLists(props.notificationFilter)
  }, [props.notificationFilter]);
  
  const paginationChange = async (page, limit) => {
    const pageData = {
      ...props.notificationFilter,
      page: page,
      limit: limit,
    };
    try {
      await props.notificationAction.filterNotificationAction(pageData);
    } catch {}
  };

  const postLists = async (value) => {
    try {
      setLoading(true);
      await props.notificationAction.getNotificationAction(value);
    } catch (e) {} finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
      if (props.notificationData){setPostData(dataKey(props.notificationData))}
  }, [props.notificationData]);



  const columns = [
    {
      title: 'Heading',
      dataIndex: 'title',
      render: (value) => (value||"-"),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      render: (value) => (value||"-"),
    },
    // {
    //   title: 'Content',
    //   dataIndex: 'content',
    //   render: (value) => (value||"-"),
    // },
    {
      title: 'Date',
      dataIndex: 'updatedAt',
      render: (value) => (<Text type="secondary">{moment(value).format("DD MMMM")}, {moment(value).format("h:mm A")}</Text>||"-"),
    },
    {
      title: 'batch',
      dataIndex: 'batch',
      render: (value) => (<TageComponents tagArray={value}/>||"-"),
    },
    {
      title: 'Rider',
      dataIndex: 'rider',
      render: (value) => (<TageComponents tagArray={value}/>||"-"),
    },
    {
      title: 'City',
      dataIndex: 'city',
      render: (value) => (<TageComponents tagArray={value}/>||"-"),
    },
    {
      title: 'Store',
      dataIndex: 'store',
      render: (value) => (<TageComponents tagArray={value} limit={true}/>||"-"),
    },
    {
      title: 'Category',
      dataIndex: 'category',
      render: (value) => (<TageComponents tagArray={value} tagKey={"title"}/>||"-"),
    },
  ]
  
  return (
    <div className="page-content">
      <div className="page-content-header">
          <Title level={2}>{pageName}</Title>
        <div className="pch">
          <Button onClick={()=>navigate(`/${pageLink}/add`)}>Add {pageName}</Button>
        </div>
      </div>
      {/* <NotificationFilter loading={loading}/> */}
      <div className="p-content">
        {loading ? <Pageloader/> : <>
          {/* <Collapse>
            {postData && postData.map((item, i) => {
              {console.log("item", item)}
              return (
                <Panel header={item?.title} key={i}>
                  <div className="page-list ffr jfcsb aifs mb-0">
                    <div className="page-list ffr jfcsb aifs rev mb-0">
                      <Text>{item?.description}</Text>
                      <Text type="secondary">{moment(item?.updatedAt).format("DD MMMM")}, {moment(item?.updatedAt).format("h:mm A")}</Text>
                    </div>
                    <div className="page-list ffr jfcsb aifs mb-0">
                      <TageComponents tagArray={item.batch}/>
                      <TageComponents tagArray={item.rider}/>
                      <TageComponents tagArray={item.city}/>
                      <TageComponents tagArray={item.store}/>
                      <TageComponents tagArray={item.category} tagKey={"title"}/>
                      
                    </div>
                  </div>
                </Panel>
              );
            })}
          </Collapse>
          {props?.notificationPagination.length !== 0 ? 
            <Pagination className="ant-table-pagination ant-table-pagination-right"
              total={props?.notificationPagination?.totalCount}
              showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
              pageSize={props?.notificationPagination?.limit}
              defaultCurrent={props?.notificationPagination?.currentPage} 
              pageSizeOptions={["10", "20", "30", "40", "50"]}
              showSizeChanger={true}
              onChange={(currentPage, pageSize) => {paginationChange(currentPage, pageSize)}}
            /> :""
          } */}

          <Table
            dataSource={postData}
            columns={columns}
            pagination={{
              total: props?.notificationPagination?.totalCount,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              pageSize: props?.notificationPagination?.limit,
              defaultCurrent: props?.notificationPagination?.currentPage,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              onChange: (currentPage, pageSize) => {paginationChange(currentPage, pageSize)},
            }}
            onRow={(r) => ({onDoubleClick: () => window.open(`/${pageLink}/${r.id}`)})}
          />
        </>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    notificationData: state.NotificationReducer.notificationData,
    notificationPagination: state.NotificationReducer.notificationPagination,
    notificationFilter: state.NotificationReducer.notificationFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    notificationAction: bindActionCreators(notificationAction, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NotificationListing);